import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pos-left bg-white rounded-1" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-12 d-flex gap-2" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "category-scroll-container mb-3" }
const _hoisted_7 = {
  class: "nav nav-tabs pos-tablist d-flex flex-nowrap border-0 gap-2",
  role: "tablist",
  style: {"overflow-x":"auto","padding-bottom":"5px"}
}
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  class: "category-icon mb-2 rounded-circle d-flex align-items-center justify-content-center bg-light",
  style: {"width":"45px","height":"45px"}
}
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "fs-12 fw-medium text-dark text-truncate w-100 px-1" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  class: "category-icon mb-2 rounded-circle d-flex align-items-center justify-content-center bg-white shadow-sm",
  style: {"width":"45px","height":"45px","overflow":"hidden"}
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "fs-12 fw-medium text-dark text-truncate w-100 px-1" }
const _hoisted_16 = { class: "pos-grid mt-30" }
const _hoisted_17 = {
  key: 0,
  class: "text-center py-5 text-muted"
}
const _hoisted_18 = { class: "row gx-3 gy-3" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "product-item text-center border rounded p-0 overflow-hidden h-100 d-flex flex-column" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "p-2 d-flex flex-column flex-grow-1" }
const _hoisted_23 = { class: "fs-12 text-optional d-block lh-1 mb-1" }
const _hoisted_24 = { class: "fs-14 fw-semibold text-title mb-1 lh-1" }
const _hoisted_25 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_26 = { class: "fs-12 mb-0 text-primary fw-bold" }
const _hoisted_27 = { class: "d-flex justify-content-end align-items-center mt-auto" }
const _hoisted_28 = { class: "d-flex gap-1 flex-wrap justify-content-end" }
const _hoisted_29 = {
  key: 0,
  class: "badge bg-primary-subtle text-primary border border-primary-subtle fs-10 px-1"
}
const _hoisted_30 = {
  key: 1,
  class: "badge bg-info-subtle text-info border border-info-subtle fs-10 px-1"
}
const _hoisted_31 = {
  key: 0,
  class: "col-12 text-center py-5"
}
const _hoisted_32 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select w-auto",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWarehouseId) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (w) => {
            return (_openBlock(), _createElementBlock("option", {
              key: w.id,
              value: w.id
            }, _toDisplayString(w.name), 9, _hoisted_4))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedWarehouseId]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: _ctx.$t('common.search_by_name_or_code'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event))
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.searchQuery]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link btn style-one rounded-3 d-flex flex-column align-items-center justify-content-center p-2 transition-all", { active: _ctx.selectedCategoryId === null }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedCategoryId = null)),
            type: "button",
            style: {"min-width":"90px","height":"90px"}
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _ctx.defaultCategoryImg,
                alt: _ctx.$t('common.all'),
                style: {"width":"25px","height":"25px","object-fit":"contain"}
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("common.all")), 1)
          ], 2)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item",
            key: cat.id
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link btn style-one rounded-3 d-flex flex-column align-items-center justify-content-center p-2 transition-all", { active: _ctx.selectedCategoryId === cat.id }]),
              onClick: ($event: any) => (_ctx.selectedCategoryId = cat.id!),
              type: "button",
              style: {"min-width":"90px","height":"90px"}
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _ctx.getCategoryImage(cat),
                  alt: "icon",
                  style: {"width":"100%","height":"100%","object-fit":"cover"}
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(cat.name), 1)
            ], 10, _hoisted_12)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("pos.loading_products")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-4 col-md-6 col-sm-6",
            key: product.id,
            onClick: ($event: any) => (_ctx.addToCart(product))
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("img", {
                src: _ctx.getProductImage(product),
                alt: "Image",
                class: "d-block w-100 border-bottom",
                style: {"height":"140px","object-fit":"contain","background":"#f8f9fa"}
              }, null, 8, _hoisted_21),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(product.category?.name || _ctx.$t('pos.no_category')), 1),
                _createElementVNode("h6", _hoisted_24, _toDisplayString(product.name), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.stateStore.formatPrice(product.price || 0)), 1),
                  (product.type === 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([
                  'badge fs-10 px-1 border',
                  _ctx.getAvailableStock(product) > 0 ? 'bg-success-subtle text-success border-success-subtle' : 'bg-danger-subtle text-danger border-danger-subtle'
                ])
                      }, _toDisplayString(_ctx.$t("pos.stock")) + ": " + _toDisplayString(_ctx.getAvailableStock(product)), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    (product.product_sizes?.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t(product.product_sizes.length > 1 ? "pos.sizes" : "pos.size")) + " : " + _toDisplayString(product.product_sizes.map(ps => ps.size?.name || '').filter(Boolean).join(', ')), 1))
                      : _createCommentVNode("", true),
                    (product.sugar_id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t("pos.sugar")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_19))
        }), 128)),
        (!_ctx.isLoading && _ctx.filteredProducts.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("pos.no_products_found")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}